<div class="view-port-detect" 
inViewport
[inViewportOptions]="{ threshold: 0.0001 }"
(inViewportAction)="onIntersection($event)">

</div>

<div class="home-article-instagram-wrapper">
    <div *ngIf="screenWidth > 1025" class="article-wrapper H-100">
        <div  class="article-slide-wrapper w-100" 
        *ngFor="let articles of articlesplited; let i = index"
         [ngClass]="{'last-active':lastActive == i, 'active-slide':activeSlide == i}">
                 <div class="article-item grid-item-space disable-grid-space article-item-{{j}}" *ngFor="let article of articles; let j = index">
                    <h3 class="heading3 font-bold f-darker heading2-m font-normal-m" [innerHtml]="article.acf.title"></h3>
                    <span class="heading6  font-light f-darker">{{article.acf.date}}  ·  {{article.acf.read_time}}</span>
                    <a class="link1 link-darker" target="_blank" href="{{article.acf.link}}">{{article.acf.link_label}}</a>
                </div>
        </div>
        <div class="dots-wrapper article-dots-wrapper">
            <a (click)="activeSlideDots(i)" class="gallery-dots"  *ngFor="let articles of articlesplited;  let i = index">
                <div class="dots-inner-wrapper dark-dots" [ngStyle]="{'width': labelwidth +'px'}">
                    <mat-progress-bar *ngIf="activeSlide == i" mode="determinate" value="{{width}}"></mat-progress-bar>
                </div>
            </a>
        </div>
    </div>
    <div *ngIf="screenWidth <= 1024" class="article-wrapper" [ngClass]="{'animate':fadecontent}"
    (swipeleft)="onSwipeLeft()"
    (swiperight)="onSwipeRight()"
    >
        <div  class="article-slide-wrapper w-100"         
            *ngFor="let article of articles; let i = index"
            [ngClass]="{'last-active':lastActive == i, 'active-slide':activeSlide == i}">
            <div class="article-item grid-item-space disable-grid-space">
                <h4 class="heading5 element-header">From the blog</h4>
                <h3 class="heading3 font-bold f-darker heading-3-m font-normal-m" [innerHtml]="article.acf.title"></h3>
                <span class="heading6  font-light f-darker">{{article.acf.date}}  ·  {{article.acf.read_time}}</span>
                <a class="link1-mobile link-darker" target="_blank" href="{{article.acf.link}}">{{article.acf.link_label}}</a>
            </div>
        </div>
        <div class="dots-wrapper article-dots-wrapper">
            <a (click)="activeSlideDots(i)" class="gallery-dots"  *ngFor="let article of articles;  let i = index">
                <div class="dots-inner-wrapper  dark-dots" [ngStyle]="{'width': labelwidth +'px'}">
                    <mat-progress-bar *ngIf="activeSlide == i" mode="determinate" value="{{width}}"></mat-progress-bar>
                </div>
            </a>
        </div>
    </div>
    <div class="instagram-wrapper H-100">
        <div 
            class="viewport-instagram"
            inViewport
            [inViewportOptions]="{ threshold: 0.0001 }"
            (inViewportAction)="onIntersectionInstagram($event)">
        </div>
        <div class="instagram-inner-wrapper grid-item-space disable-grid-space" [ngClass]="{'animate':animate}" [@fadeIn]="filtershowinstagrams?.length">

            <div  class="insta-item" [ngClass]="{'insta-item-hidden': instaHidden == i}" *ngFor="let instagram of filtershowinstagrams| slice:0:4; let i = index">
                <app-instagram-item class="w-100 h-100" [instagram]="instagram"></app-instagram-item>
            </div>
            <div *ngIf="screenWidth > 1024" class="follow-us" [ngClass]="{'follow-animate':animate}" [@fadeIn]="filtershowinstagrams?.length">
                <h3 class="heading4 font-normal text-center f-white heading-5-m"> <a target="_blank" class="f-white" href="{{instagramData.url}}">@{{instagramData.handle}}</a> <br> on instagram <br> </h3>
            </div> 
            <a *ngIf="screenWidth <= 1024" class="follow-us" target="_blank" href="{{instagramData.url}}" [ngClass]="{'follow-animate':animate}" [@fadeIn]="filtershowinstagrams?.length">
                <h3 class="heading4 font-normal text-center f-white heading-5-m"> <a target="_blank" class="f-white" href="{{instagramData.url}}">@{{instagramData.handle}}</a> <br> on instagram <br> </h3>
            </a>
            <div  class="insta-item" [ngClass]="{'insta-item-hidden': instaHidden == (i + 4)}" *ngFor="let instagram of filtershowinstagrams| slice:4:8; let i = index">
                <app-instagram-item class="w-100 h-100" [instagram]="instagram"></app-instagram-item>
            </div>
        </div> 
    </div>
</div>